var React = require('react');

function SliderArrowBlack (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23 26L17 21L23 16","stroke":"black","strokeWidth":"1.6","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M0.500002 21C0.500001 9.67816 9.67816 0.499999 21 0.499998C32.3218 0.499997 41.5 9.67816 41.5 21C41.5 32.3218 32.3218 41.5 21 41.5C9.67817 41.5 0.500003 32.3218 0.500002 21Z","stroke":"black","strokeOpacity":"0.3","key":1})]);
}

SliderArrowBlack.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = SliderArrowBlack;

SliderArrowBlack.default = SliderArrowBlack;
